module.exports = __webpack_public_path__ + "static/media/logo.71d3a237.png";